<template>
  <div class="input-model d-c-c d-r full">
    <el-input size="mini" v-model="pre" @blur="formatResult">
      <template slot="suffix"><div class="d-c-c d-r full">元</div></template>
    </el-input>
    <div class="middle-value d-c-c d-r">-</div>
    <el-input size="mini" v-model="suf" @blur="formatResult">
      <template slot="suffix"><div class="d-c-c d-r full">元</div></template>
    </el-input>
  </div>
</template>

<script>
const baseData = { pre: '', suf: '' };
const formatResult = function () {
  // const result = `${this.pre} - ${this.suf}`;
  const result = { start: this.pre, end: this.suf };
  this.$emit('input', result);  // ?
};

export default{
  name: "InputModel",
  props: {
    value: {
      type: Object,
      default: '-'
    }
  },
  watch: {
    value: function (val) {
      const { start, end } = val;
      if (start !== this.pre || end !== this.suf) {
        this.pre = start;
        this.suf = end;
      }
    }
  },
  data(){ return { ...baseData } },
  methods:{ formatResult },
  created(){}
}
</script>

<style lang="scss" scoped>
.input-model {
  width: 100%;
  .full {
    width: 100%;
    height: 100%;
  }
  .middle-value {
    width: 10%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/collection/collection_cases/component/unit/InputModel.vue